module.exports = __webpack_public_path__ + "static/media/img_intro.f37cffd1.png";